const icon = require('vue-svgicon');
icon.register({
    'cart_old': {
        width: 512,
        height: 512,
        viewBox: '0 0 512 512',
        data: `<path pid="0" d="M475.428 0v512H36.571V0h438.857zM164.571 73.143c-30.297 0-54.857 24.561-54.857 54.857s24.56 54.857 54.857 54.857h182.857c30.297 0 54.857-24.56 54.857-54.857s-24.56-54.857-54.857-54.857H164.571z"/>`,
    },
});
